import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { motion } from "framer-motion";

import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";

import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";

import qImg1 from "@/assets/images/webp/quality-business-leads-img.webp";
import qImg2 from "@/assets/images/webp/quality-business-key-highlight-1.webp";
import qImg3 from "@/assets/images/webp/quality-business-key-highlight-2.webp";
import qImg4 from "@/assets/images/webp/quality-business-key-highlight-3.webp";
import qImg5 from "@/assets/images/webp/quality-business-authentic-global-connections-img.webp";
import qImg6 from "@/assets/images/webp/quality-business-use-member-tool-img.webp";



const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  useEffect(() => {
    setSelectedLanguage(localStorage.getItem("web_lang"));
  }, []);

  return (
    <>
      <SeoHelmet
        title={seoConfig.qualityLeads.title}
        description={seoConfig.qualityLeads.description}
        keywords={seoConfig.qualityLeads.keywords}
        author={seoConfig.qualityLeads.author}
      />
      <div>
        <button
          className="btn outline small sticky-btn"
          onClick={handleQuoteClick}
          type="button"
        >
          Book A Demo
        </button>
        <section className="quality-business-leads">
          {/* inner banner wrape START  */}
          <div className="inner-banner">
            <div className="container">
              {
                selectedLanguage === "en" ? <div className="content-wrape desk-hide">
                  <h2>
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Quality</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Business</motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Leads</motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Connect, Communicate & Convert Faster</motion.p>
                </div> : <div className="content-wrape desk-hide">
                  <h2>
                    <span className={`light`}>Quality</span>
                    <span className={`blue-text `}> Business</span>
                    <span className={`black`}> Leads</span>
                  </h2>
                  <p className={``}>Connect, Communicate & Convert Faster</p>
                </div>
              }

            </div>
          </div>
          {/* inner banner wrape END  */}

          {/* inner page content START */}
          <div className="inner-page-content-wrape global-trade-network-page">
            <div className='container'>
              {
                selectedLanguage === "en" ? <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Quality</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Business</motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Leads</motion.span>
                    {/* <span className={`black ${visible ? "animate__animated animate__fadeInUp animate__delay-400ms" : "opacity-0"}`}> Network</span> */}
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Connect, Communicate & Convert Faster</motion.p>
                </div> : <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <span className={`light`}>Quality</span>
                    <span className={`blue-text `}> Business</span>
                    <span className={`black`}> Leads</span>
                    {/* <span className={`black ${visible ? "animate__animated animate__fadeInUp animate__delay-400ms" : "opacity-0"}`}> Network</span> */}
                  </h2>
                  <p className={``}>Connect, Communicate & Convert Faster</p>
                </div>
              }


              <div className="subtext-wrape">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.h1 className={`animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >High-Quality Leads</motion.h1>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.p className={`medium-size animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Orex Trade helps you access high-quality, verified leads that support faster, safer and more reliable global trade. Our system ensures every connection is genuine, allowing you to grow your network and convert opportunities with confidence.</motion.p>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                  <div className='img-wrape'>
                    <motion.img src={qImg1} alt='Quality Business Leads' loading="lazy"
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </div>
                </div>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                  <div className='content-wrape'>
                    <div className="head-text">
                      <motion.h2 className="head animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Quality Business Leads
                      </motion.h2>
                    </div>

                    <motion.h6 className="varient animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Connect, Interact & Accelerate Growth</motion.h6>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Generate high-quality, verified business leads with Orex Trade’s Quotation System,  a seamless tool built to simplify global trade communication. Orex Trade bridges the gap between buyers, suppliers and logistics partners, enabling you to exchange inquiries and quotations in minutes. No more long email threads or missed opportunities - just fast, transparent and reliable trade connections.
                    </motion.p>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      The Orex Trade Quotation System is a free feature available exclusively to registered members. It streamlines your lead generation and business matching process by providing structured, accurate and secure inquiry communication ensuring every quote request turns into a potential business opportunity.
                    </motion.p>
                  </div>
                </div>
              </div>

              {/* verification global network START */}
              <div className="verification-global-wrape" id="smart-inquiry">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="head-text center">
                      <motion.h2 className="head center animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Smart Inquiry & Quotation System
                      </motion.h2>
                      <motion.p className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >The Smart Inquiry & Quotation System allows you to send and receive detailed trade inquiries effortlessly within the Orex Trade network. Designed for simplicity and accuracy, it eliminates the confusion of back-and-forth emails and speeds up your business communication.</motion.p>

                      <motion.p className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >By following a structured inquiry format, both buyers and suppliers can exchange all necessary details upfront - ensuring precise and professional responses. Whether you’re sourcing products, offering services or coordinating logistics, the Orex Trade system ensures smooth, quick and reliable trade interactions.</motion.p>
                    </div>
                  </div>

                  <div className="col-xxl-12">
                    <motion.h5 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Key Highlights</motion.h5>
                    <div className="row custom-scroll-row">
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={qImg2} alt='Structured inquiry templates for accurate communication' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Structured inquiry templates for accurate communication</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={qImg3} alt='Reduces confusion and manual coordination' loading="lazy" className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Reduces confusion and manual coordination</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={qImg4} alt='Enhances trust through clear, documented exchanges' loading="lazy" className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Enhances trust through clear, documented exchanges</motion.p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* verification global network END */}
            </div>


            {/* globalPartnerwrape START */}
            <div className="global-partner-wrape" id="authentic-connection">
              <div className="img-wrape">
                <img src={qImg5} alt='Global partner' loading="lazy" />
              </div>
              <div className="detail-wrape">
                <div className="inner-pad">
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Authentic Global Connections
                    </motion.h2>
                  </div>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >With Orex Trade, every lead comes from a verified buyer, supplier or logistics partner ensuring you only engage with genuine businesses. Each member is carefully screened to build a network based on authenticity, credibility and trust.</motion.p>
                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >This verification process minimizes fake inquiries and unreliable responses, helping you focus on building long-term, profitable relationships. By connecting with pre-verified trade partners, you can confidently expand your global reach and secure meaningful business opportunities.</motion.p>
                  <motion.h5 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Key Highlights</motion.h5>
                  <ul>
                    <motion.li className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Verified members across 80+ countries
                    </motion.li>
                    <motion.li className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Eliminate spam and low-quality leads
                    </motion.li>
                    <motion.li className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Build relationships with credible businesses
                    </motion.li>
                    <motion.li className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Save time and improve lead conversion rates
                    </motion.li>
                  </ul>
                </div>
              </div>
            </div>
            {/* globalPartnerwrape END */}

            {/* market-inteligence-wrape START */}
            <div className="container market-inteligence-wrape" id="member-tool">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div className="detail-wrape">
                    <div className="inner-pad">
                      <div className="head-text">
                        <motion.h2 className="head animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          Free & Easy-to-Use Member Tool
                        </motion.h2>
                      </div>
                      <motion.p className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >The Orex Trade Quotation System is completely free for all registered paid members, giving every business big or small, equal access to quality trade opportunities. With its intuitive design, you can easily send or respond to inquiries from your dashboard, without needing additional software or tools.</motion.p>

                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >This simple yet powerful feature helps businesses operate efficiently, saving time and cost while boosting global visibility. From first inquiry to confirmed partnership, Orex Trade ensures every step of your trade process is effortless and secure.</motion.p>
                      <div className="clearfix"></div>
                      <motion.h5 className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Key Highlights</motion.h5>
                      <ul>
                        <motion.li className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Free access for all Orex Trade paid members
                        </motion.li>
                        <motion.li className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Simple, user-friendly quotation interface
                        </motion.li>
                        <motion.li className="animate-child">
                          <i className="sprite"></i>
                          No additional software or subscription needed other than membership
                        </motion.li>
                        <motion.li className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Streamlined inquiry management and follow ups
                        </motion.li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <motion.img src={qImg6} alt='Free & Easy-to-Use Member Tool' loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
            </div>
            {/* market-inteligence-wrape END */}

            {/* gray wrape START */}
            <div className="gray-wrape">
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12">
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >With Orex Trade’s Quality Business Leads global trade becomes faster, smarter and more reliable. Our Smart Quotation System, Verified Connections and Free Member Tools empower you to generate genuine leads, communicate effectively and grow your business confidently across borders</motion.p>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Connect. Communicate. Convert with Orex Trade</motion.p>
                  </div>
                </div>
              </div>
            </div>
            {/* gray wrape END */}

          </div>
          {/* inner page content END */}
        </section>
      </div>
      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        // onSubmit={handleRegistrationPopup}
        // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
        // }
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </>
  );
};

export default Index;